<template>
<div class="ui_couponTrigger" v-if="isShowGift">
    <div class="mask">
        <div class="couponBox">
            <div class="topBox">
                <img src="https://xcx.ihotel.cn/hotel/images/couponTrigger/couponTriggerClose.png" alt="" class="couponTriggerClose" @click.stop="hideGift">
            </div>
            <div class="bottomBox">
                <div class="titleBox">
                    <p class="bigTitle">幸运降临</p>
                    <img src="https://xcx.ihotel.cn/hotel/images/couponTrigger/couponTriggerStar.png" alt="" class="couponTriggerStar">
                    <img src="https://xcx.ihotel.cn/hotel/images/couponTrigger/couponTriggerStar.png" alt="" class="couponTriggerStar couponTriggerStar2">
                    <p class="subTitle">恭喜您获得大礼包</p>
                </div>
                <div class="middleBox">
                    <div class="couponItem">
                        <div class="couponLeft">
                            <p class="price"><em>¥</em>50</p>
                        </div>
                        <div class="couponRight">
                            <p class="couponName">50元门票惊喜大礼包50元门票惊喜大礼包</p>
                            <p class="couponDesc">使用条件使用条件使用使用条件使用条件使用使用条件使用条件使用</p>
                        </div>
                    </div>
                </div>
                <div class="footerBox">
                    <div class="getBtn">立即领取</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import api from "@/utils/api";
import {
    jAlert3,
    jAlert5
} from "@/base/jAlert/jAlert";
import {
    getStorage
} from "@/utils/wxuser";
import { createUrl } from "@/utils/index";

var config = {};
export default {
    data() {
        return {
            isShowGift: false,
            user: getStorage('user')
        };
    },
    methods: {
        showGift() {
            this.isShowGift = true;
        },
        hideGift() {
            this.isShowGift = false;
        },
        getCanTriggerRuleList(query = {}) {
            let obj = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
            }
            api.getCanTriggerRuleList(Object.assign(obj, query)).then(res => {
                if (res.result == 1) {
                    if (res.retVal && res.retVal.length > 0) {
                        var opt = {
                            hotelGroupCode: config.hotelGroupCode,
                            hotelCode: config.hotelCode,
                            code: res.retVal[0].code,
                            appid:config.appid,
                            hotelId:config.hotelId,
                            scene:res.retVal[0].scene
                        }
                        if (this.user.memberId) {
                            opt.memberId = this.user.memberId;
                            opt.mobile = this.user.mobile;
                            var chuzhiIndex = getStorage("cardIndex") || 0;
                            opt.cardId = this.user.cardListDto[chuzhiIndex].cardId;
                            opt.cardNo = this.user.cardListDto[chuzhiIndex].cardNo;
                            opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                        }
                        // opt.url = createUrl(opt)
                        api.getCanReceiveCouponList(opt).then(res => {

                        })
                    }

                }
            })
        },
        init(query) {
            this.getCanTriggerRuleList(query)
        }
    },
    created() {
        config = getStorage("config");
    },
    mounted() {
        this.init()
    }
};
</script>

<style lang="less" scoped>
@import url('~@/styles/mixin.less');

.ui_couponTrigger {
    position: fixed;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    z-index: 120;

    .mask {
        position: fixed;
        left: 0;
        right: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;

        .couponBox {
            .topBox {
                height: 120px;
                width: 280px;
                background-image: url("https://xcx.ihotel.cn/hotel/images/couponTrigger/couponTriggerBg.png");
                background-size: 100% 100%;
                position: relative;

                .couponTriggerClose {
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }

            .bottomBox {
                min-height: 265px;
                background-image: linear-gradient(180deg, #ffa264 0%, #f60939 100%);
                border-radius: 12px;
                width: 265px;

                .titleBox {
                    height: 88px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position: relative;

                    .couponTriggerStar {
                        height: 12px;
                        width: 12px;
                        position: absolute;
                        left: 60px;
                        top: 15px;

                        &.couponTriggerStar2 {
                            left: 192px;
                            top: 33px;
                        }
                    }

                    .bigTitle {
                        margin-bottom: 12px;
                        font-size: 26px;
                        color: #fefef2;
                        text-align: center;
                        text-shadow: 0 2px 3px rgba(222, 35, 0, 0.5);
                        position: relative;
                    }

                    .subTitle {
                        font-size: 18px;
                        color: #ffffff;
                        letter-spacing: 2px;
                        text-align: center;
                    }
                }

                .middleBox {
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 8px;
                    padding: 10px;
                    width: calc(~"100% - 12px");
                    margin: 0 auto;
                    min-height: 106px;
                    max-height: 230px;
                    overflow-y: scroll;

                    .couponItem {
                        height: 86px;
                        margin-bottom: 12px;
                        background: #FFFFFF;
                        border-radius: 12px;
                        display: flex;
                        -webkit-mask-image: radial-gradient(circle at 76px 4px, transparent 4px, red 4.5px), linear-gradient(transparent 25%, red 0, red 75%, transparent 0);
                        -webkit-mask-size: 100%, 2px 6px;
                        -webkit-mask-repeat: repeat, repeat-y;
                        -webkit-mask-position: 0 -4px, 75px;
                        -webkit-mask-composite: source-out;
                        mask-composite: subtract;

                        .couponLeft {
                            width: 76px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .price {
                                font-size: 21px;
                                color: #E72E35;

                                em {
                                    font-size: 14px;
                                }
                            }
                        }

                        .couponRight {
                            width: calc(~"100% - 76px");
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            padding-left: 12px;

                            .couponName {
                                font-size: 14px;
                                color: #333333;
                                margin-bottom: 8px;
                                .textHidden();
                            }

                            .couponDesc {
                                font-size: 12px;
                                color: #999999;
                                .textHidden();
                            }
                        }
                    }
                }

                .footerBox {
                    height: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .getBtn {
                        background-image: linear-gradient(180deg, #fdec89 0%, #ffab35 100%);
                        border-radius: 22px;
                        height: 38px;
                        width: 160px;
                        font-size: 16px;
                        color: #6b0012;
                        text-align: center;
                        line-height: 38px;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/couponTrigger.vue